import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-foreground-950 mb-4">
              <i className="ri-book-2-line text-2xl text-primary-500"></i>
              <span className="text-lg font-semibold whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                经典文学研究院
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专注中国古典文学研究与推广，以严谨的学术态度和开放的文化视野，架设经典与当代之间的桥梁。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="hover:text-primary-500 transition-colors">分类浏览</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { path: '/category/historical-background', label: '历史背景' },
                { path: '/category/literary-value', label: '文学价值' },
                { path: '/category/version-research', label: '版本考证' },
                { path: '/category/cultural-influence', label: '文化影响' },
                { path: '/category/character-analysis', label: '人物解析' },
                { path: '/category/academic-research', label: '学术研究' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-contact" className="hover:text-primary-500 transition-colors">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <span>北京市海淀区中关村南大街5号 文化大厦B座12层</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-foreground-400"></i>
                <span>010-8888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>contact@jingdianwenxue.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 经典文学研究院 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-500 transition-colors">关于我们</Link>
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}